module.exports = __webpack_public_path__ + "img/57.ebe452d2.png";